import { configure } from 'mobx';

import Config from 'modules/config';

if (Config.ENV === 'development') {
  console.devLog.info('In dev mode, setting mobx strict checking');
  configure({
    enforceActions: 'observed',
    computedRequiresReaction: true,
  });
}
